var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketScopeAdvisor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414.88 50.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #002b5a;\n      }\n\n      .cls-2 {\n        fill: #007bb8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,23.52h10.03l5.15,14.31,5.15-14.31h9.84v26.85h-7.66v-16.71l-6.57,16.71h-2.55l-6.5-16.71v16.71H0v-26.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.38,23.52h9.95l8.53,26.85h-8.15l-1.43-5h-8.9l-1.43,5h-7.17l8.6-26.85Zm1.5,16.56h5.9l-2.93-10.33-2.97,10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.59,23.52h10.52c7.02,0,10.93,2.85,10.93,8.53v.15c0,3.83-2.03,5.97-4.85,7.06l6.42,11.12h-8.11l-5.45-9.61h-1.8v9.61h-7.66v-26.85Zm10.14,12.24c2.59,0,3.87-1.09,3.87-3.27v-.15c0-2.18-1.35-3.04-3.83-3.04h-2.52v6.46h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.3,23.52h7.74v10.63l8.07-10.63h8.04l-9.84,12.47,10.37,14.39h-8.9l-7.74-11.23v11.23h-7.74v-26.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m111.34,23.52h18.55v5.93h-10.89v4.62h8.68v5.48h-8.68v4.88h11.49v5.93h-19.15v-26.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m139.47,29.45h-6.95v-5.93h21.63v5.93h-6.95v20.92h-7.74v-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.87,41.84h7.32c.19,1.92,1.05,3.49,4.24,3.49,2.22,0,3.46-1.09,3.46-2.67s-1.01-2.1-4.24-2.59c-7.59-.9-10.14-3.15-10.14-8.56,0-4.85,3.98-8.38,10.4-8.38s10.1,2.7,10.59,8.38h-7.14c-.26-1.92-1.35-2.89-3.46-2.89s-3.12.94-3.12,2.29c0,1.5.83,2.18,4.17,2.63,6.8.75,10.29,2.52,10.29,8.34,0,4.92-3.91,8.94-10.82,8.94-7.51,0-11.34-3.15-11.57-8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m178.61,37.11v-.3c0-8.26,5.86-13.71,13.71-13.71,6.99,0,11.83,3.23,12.47,10.33h-7.92c-.3-2.74-1.8-4.24-4.51-4.24-3.46,0-5.63,2.7-5.63,7.59v.3c0,4.84,2.07,7.59,5.75,7.59,2.7,0,4.62-1.43,5-4.39h7.66c-.53,6.95-5.56,10.55-12.51,10.55-9.39,0-14.01-5.48-14.01-13.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m206.59,37.11v-.3c0-8.19,6.16-13.67,14.2-13.67s14.23,5.15,14.23,13.48v.3c0,8.26-5.67,13.9-14.35,13.9s-14.08-5.63-14.08-13.71Zm20.39-.08v-.3c0-4.77-2.4-7.59-6.2-7.59s-6.16,2.74-6.16,7.62v.3c0,4.88,2.48,7.7,6.2,7.7s6.16-2.93,6.16-7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m237.13,23.52h10.22c7.36,0,10.78,3.27,10.78,8.98v.15c0,5.63-3.79,8.68-10.44,8.68h-2.89v9.05h-7.66v-26.85Zm9.88,12.54c2.48,0,3.79-1.16,3.79-3.38v-.15c0-2.29-1.35-3.23-3.76-3.23h-2.25v6.76h2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m260.27,23.52h18.55v5.93h-10.89v4.62h8.68v5.48h-8.68v4.88h11.49v5.93h-19.15v-26.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m298.21,23.52h4.28l9.09,26.85h-3.23l-2.63-7.74h-11.08l-2.59,7.74h-3.08l9.24-26.85Zm-2.67,16.53h9.31l-4.66-13.82-4.66,13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m312.52,40.94v-.3c0-6.01,3.76-10.25,9.16-10.25,3.27,0,5.3,1.58,6.42,3.49v-12.54h3.12v29.03h-3.12v-3.38c-1.13,1.92-3.87,3.72-6.72,3.72-5.15,0-8.86-3.64-8.86-9.76Zm15.7-.26v-.3c0-5.03-2.4-7.4-6.24-7.4s-6.23,2.74-6.23,7.51v.3c0,4.96,2.67,7.32,5.97,7.32,3.64,0,6.5-2.4,6.5-7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m333.93,30.73h3.38l5.82,16.49,5.75-16.49h3.23l-7.06,19.64h-3.98l-7.14-19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m355.72,24.57c0-1.13.94-2.07,2.07-2.07s2.07.94,2.07,2.07-.94,2.07-2.07,2.07-2.07-.94-2.07-2.07Zm.56,6.16h3.12v19.64h-3.12v-19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m364.17,44.32h3.04c.23,2.33,1.46,3.79,4.62,3.79,2.97,0,4.28-1.01,4.28-3.12s-1.54-2.74-4.58-3.3c-5.11-.94-6.84-2.37-6.84-5.78,0-3.64,3.57-5.52,6.65-5.52,3.53,0,6.57,1.43,7.1,5.67h-3c-.45-2.14-1.65-3.08-4.13-3.08-2.25,0-3.72,1.13-3.72,2.82s.98,2.48,4.58,3.12c4.06.75,6.91,1.65,6.91,5.82,0,3.57-2.44,5.97-7.21,5.97s-7.51-2.37-7.7-6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m382.12,40.72v-.3c0-5.9,4.09-10.03,9.65-10.03s9.65,4.09,9.65,9.99v.3c0,5.93-4.09,10.03-9.69,10.03s-9.61-4.24-9.61-9.99Zm16.08,0v-.26c0-4.54-2.52-7.47-6.42-7.47s-6.42,2.93-6.42,7.44v.3c0,4.47,2.44,7.4,6.42,7.4s6.42-2.97,6.42-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m405.3,30.73h3.12v3.53c1.24-2.22,2.93-3.76,6.46-3.87v2.93c-3.94.19-6.46,1.43-6.46,6.27v10.78h-3.12v-19.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,9.56v.1C0,4.25,4.37,0,10.28,0c3.99,0,6.55,1.59,8.28,3.87l-4.07,3c-1.12-1.33-2.4-2.18-4.27-2.18-2.73,0-4.66,2.2-4.66,4.91v.05c0,2.78,1.92,4.96,4.66,4.96,2.04,0,3.23-.9,4.4-2.26l4.07,2.76c-1.84,2.42-4.32,4.2-8.64,4.2C4.48,19.31,0,15.25,0,9.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.88 .02 34.99 .02 34.99 4.79 24.65 4.79 24.65 7.97 34.19 7.97 34.19 11.95 24.65 11.95 24.65 19.1 19.88 19.1 19.88 .02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.58.87v18.23h5.57S36.58.87,36.58.87Zm14.02,11.55c2.12-1.03,3.47-2.8,3.47-5.36v-.83c0-1.8-.57-3.2-1.69-4.24C51.09.75,49.07.02,46.14.02h-9.32l5.32,8.29v-3.52h3.48c1.78,0,2.88.79,2.88,2.35v.24c0,1.33-1.08,2.18-2.97,2.18h-2.81l6.93,9.54h5.92l-4.96-6.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.1.82h-5.09l-7.08,15.97,1.22,1.72.43.6h2.98l1.33-3.18h7.21l1.36,3.18h5.76L67.1.82Zm-4.75,11.13l2.16-5.19,2.14,5.19h-4.29Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketScopeAdvisor);
export default __webpack_public_path__ + "static/media/MarketScopeAdvisor.6fc6f50023ea694742e58970cb6a3135.svg";
export { ForwardRef as ReactComponent };